module.exports = __webpack_public_path__ + "static/CardOfDarkness0-ab46988b8a1cd906eb40675717191434.webp";